<div class="register-layout">
  <div class="row form-layout py-4">
    <div class="col-md-10 form position-relative">
      <div class="mt-1">
        <div class="form-label ">
          <h1 class="dashboard-sub-heading">Trading Limits</h1>
        </div>

        <hr>

        <div class="row">
          <form class="row g-3 mt-5" [formGroup]="tradeLimitForm"  novalidate [ngClass]="loading ? 'blur-background' : ''">
            <!-- <div class="form-label ">
                <h2 class="dashboard-sub-heading">Add Bank Account</h2>
            </div>

            <hr> -->

            <div class="row">
              <div class="col-md-3 text-start">
                Trading Currency
              </div>
              <div class="col-md-6 text-start">
                <select class="form-select" aria-label="Default select example"
                        formControlName="currency"
                        [ngClass]="{'is-invalid': tradeLimitSubmitted && formTradeLimitControl['currency'].errors}">
                  <option [ngValue]="currency.type" *ngFor="let currency of currencyList">
                    {{currency.type}} - {{currency.description}}
                  </option>
                </select>
                <div *ngIf="tradeLimitSubmitted && formTradeLimitControl['currency'].errors"
                     class="invalid-feedback">
                  <div *ngIf="formTradeLimitControl['currency'].errors['required']">
                    Select a Currency
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-3 text-start">
                OD Limit
              </div>
              <div class="col-md-6 text-start">
                <input type="number"  class="form-control" id="odLimit"
                       formControlName="odLimit"
                       [ngClass]="{ 'is-invalid': tradeLimitSubmitted && formTradeLimitControl['odLimit'].errors }"
                       [disabled]="true">
                <div *ngIf="tradeLimitSubmitted && formTradeLimitControl['odLimit'].errors"
                     class="invalid-feedback">
                  <div *ngIf="formTradeLimitControl['odLimit'].errors['required']">
                    OD Limit is required
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-3 text-start">
                Margin Limit
              </div>
              <div class="col-md-6 text-start">
                <input type="number"  class="form-control" id="marginLimit"
                       formControlName="marginLimit"
                       [ngClass]="{ 'is-invalid': tradeLimitSubmitted && formTradeLimitControl['marginLimit'].errors }">
                <div *ngIf="tradeLimitSubmitted && formTradeLimitControl['marginLimit'].errors"
                     class="invalid-feedback">
                  <div *ngIf="formTradeLimitControl['marginLimit'].errors['required']">
                    Margin Limit is required
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-3 text-start">
                Day Trading Limit
              </div>
              <div class="col-md-6 text-start">
                <input type="number"  class="form-control" id="dayTradingLimit"
                       formControlName="dayTradingLimit"

                       [ngClass]="{ 'is-invalid': tradeLimitSubmitted && formTradeLimitControl['dayTradingLimit'].errors }">
                <div *ngIf="tradeLimitSubmitted && formTradeLimitControl['dayTradingLimit'].errors"
                     class="invalid-feedback">
                  <div *ngIf="formTradeLimitControl['dayTradingLimit'].errors['required']">
                    Day Trading Limit is required
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex" style="justify-content:flex-end;">
              <div class="">
                <div class="p-2">
                  <button  type="button" class="btn btn-primary mt-4" type="submit"
                           [disabled]="tradingLimitDone"
                           (click)="addTradeLimit()"
                  >
                    <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p *ngIf="!loading">
                      Create
                    </p>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="mt-2" *ngIf="isMasterLimit">
        <div class="form-label ">
          <h1 class="dashboard-sub-heading">Master Limits</h1>
        </div>

        <hr>

        <div class="row">
          <form class="row g-3 mt-5" [formGroup]="masterLimitForm"  novalidate [ngClass]="loading ? 'blur-background' : ''">
            <!-- <div class="form-label ">
                <h2 class="dashboard-sub-heading">Add Bank Account</h2>
            </div>

            <hr> -->

            <div class="row">
              <div class="col-md-3 text-start">
                Master Limit Currency
              </div>
              <div class="col-md-6 text-start">
                <select class="form-select" aria-label="Default select example"
                        formControlName="masterLimitCurrency"
                        [ngClass]="{'is-invalid': masterTradeLimitSubmitted && formMasterTradeLimitControl['masterLimitCurrency'].errors}">
                  <option [ngValue]="currency.type" *ngFor="let currency of currencyList">
                    {{currency.type}} - {{currency.description}}
                  </option>
                </select>
                <div *ngIf="masterTradeLimitSubmitted && formMasterTradeLimitControl['masterLimitCurrency'].errors"
                     class="invalid-feedback">
                  <div *ngIf="formMasterTradeLimitControl['masterLimitCurrency'].errors['required']">
                    Select a Currency
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-3 text-start">
                Master Limit
              </div>
              <div class="col-md-6 text-start">
                <input type="number"  class="form-control" id="masterLimit"
                       formControlName="masterLimit"
                       [ngClass]="{ 'is-invalid': masterTradeLimitSubmitted && formMasterTradeLimitControl['masterLimit'].errors }"
                       [disabled]="true">
                <div *ngIf="masterTradeLimitSubmitted && formMasterTradeLimitControl['masterLimit'].errors"
                     class="invalid-feedback">
                  <div *ngIf="formMasterTradeLimitControl['masterLimit'].errors['required']">
                    Master Limit is required
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex" style="justify-content:flex-end;">
              <div class="">
                <div class="p-2">
                  <button  type="button" class="btn btn-primary mt-4" type="submit"
                           [disabled]="masterTradingLimitDone"
                           (click)="addMasterTradeLimit()"
                  >
                    <div *ngIf="loadingMaster" class="spinner-border spinner-border-sm text-light" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p *ngIf="!loadingMaster">
                      Create
                    </p>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>


